import { ActionType, createAction } from 'typesafe-actions'
import { Request } from './types'
import { ChatState } from '../../types'

export const setChatsCountByStatusWhenSearchAction = createAction(
  '@chat/SET_CHATS_COUNT_BY_STATUS_WHEN_SEARCH'
)<Request>()

const success = (state: ChatState, action: ActionType<typeof setChatsCountByStatusWhenSearchAction>): ChatState => {
  const status = action.payload.status
  switch (status) {
    case 'open':
      return {
        ...state,
        openChatsSearchCount: action.payload.count
      }
    case 'in_progress':
      return {
        ...state,
        inProgressChatsSearchCount: action.payload.count
      }
    case 'close':
      return {
        ...state,
        closeChatsSearchCount: action.payload.count
      }
    default:
      return {
        ...state
      }
  }
}

export const setChatsCountByStatusWhenSearchHandle = { asyncAction: setChatsCountByStatusWhenSearchAction, success }
